//
// Copyright 2025 DXOS.org
//

export const REM = parseFloat(getComputedStyle(document.documentElement).fontSize);
